(function () {
  'use strict';

  var IDX_CLASS = { 1: 'one', 2: 'two', 3: 'three' };

  var VITAMINES_STYLE_PAGES = [
    { path: '/pages/offre-vitamines-1-mois-bis',  slug: 'offre-vitamines-1-mois-bis' },
    { path: '/pages/offre-vitamines-1-mois',  slug: 'offre-vitamines-1-mois' },
    { path: '/pages/offre-vitamines',    slug: 'vitamines' },
    { path: '/pages/2026',               slug: '2026' },
    { path: '/pages/digestion',          slug: 'digestion' },
    { path: '/pages/hormones',           slug: 'hormones' },
    { path: '/pages/nervosite',          slug: 'nervosite' },
    { path: '/pages/premiere-commande',  slug: 'premiere-commande' },
    { path: '/pages/offre-flexible-30-tasses',  slug: 'offre-flexible-30-tasses' },
    { path: '/pages/listicle-digestion',  slug: 'listicle-digestion' },
    { path: '/pages/listicle-kids',  slug: 'listicle-kids' },
    { path: '/pages/listicle-night',  slug: 'listicle-night' },
    { path: '/pages/listicle-kids-nutrition',  slug: 'listicle-kids-nutrition' },
    { path: '/pages/listicle-kids-juice',  slug: 'listicle-kids-juice' },
  ];

  var VITAMINES_STYLE_PAGE_PATHS = VITAMINES_STYLE_PAGES.map(function (p) { return p.path; });
  var VITAMINES_STYLE_PAGE_SLUGS = VITAMINES_STYLE_PAGES.map(function (p) { return p.slug; });

  /* Pages that use the enfant-first-order logic */
  var ENFANT_FIRST_ORDER_PATHS = [
    '/pages/enfant-first-order',
    '/pages/night-first-order-pdp',
    '/pages/night-first-order-landing'
  ];

  function matchesAnyPath(pathname, paths) {
    for (var i = 0; i < paths.length; i++) {
      if (pathname.indexOf(paths[i]) !== -1) return true;
    }
    return false;
  }

  function getCurrentVitaminesSlug(pathname) {
    for (var i = 0; i < VITAMINES_STYLE_PAGES.length; i++) {
      if (pathname.indexOf(VITAMINES_STYLE_PAGES[i].path) !== -1) return VITAMINES_STYLE_PAGES[i].slug;
    }
    return null;
  }

  function updateSubtitleLabel(root, idx) {
    var cls = IDX_CLASS[idx];
    if (!cls) return;
    root.querySelectorAll('.subv_header_label.one, .subv_header_label.two, .subv_header_label.three').forEach(function (el) {
      el.style.display = el.classList.contains(cls) ? '' : 'none';
    });
  }

  /* ═══════════════════════════════════════════════════
    BAG ↔ PURCHASE MODE SYNC (sirf in pages ke liye)
    - Onetime select → Bag 1 auto-select
    - Subscription select → Bag 3 auto-select
    - Gift boxes hamesha active rahenge, bag count se koi farak nahi
      (enfant-first-order-90-day ka apna alag subscribe/onetime split hai —
      neeche forceAllGiftsActive() me handle kiya)
  ═══════════════════════════════════════════════════ */
  var BAG_MODE_SYNC_PATHS = [
    '/pages/offre-flexible-30-tasses-v2',
    '/pages/enfant-first-order-v2',
    '/pages/enfant-first-order-90-day',
    '/pages/offre-vitamines-1-mois-v2'
  ];

  function initBagModeSync() {
    if (!matchesAnyPath(window.location.pathname, BAG_MODE_SYNC_PATHS)) return;
    if (document.documentElement.dataset.subBagModeSyncInitialized) return;
    document.documentElement.dataset.subBagModeSyncInitialized = 'true';

    function forceAllGiftsActive() {
      var isNewSubPage = window.location.pathname.indexOf('/pages/enfant-first-order-90-day') !== -1;

      if (isNewSubPage) {
        /* enfant-first-order-90-day: subscribe block me sab gifts active,
           onetime block me sirf pehle 3. Poore page ke .subv_gift_box ko
           blindly active nahi karna is page pe. */
        document.querySelectorAll('.bb_gift_col').forEach(function (el) {
          el.classList.add('active');
        });
        var subscribeBlock = document.querySelector('.subscribe__save');
        var onetimeBlock   = document.querySelector('.onetime_purchase');
        if (subscribeBlock) {
          subscribeBlock.querySelectorAll('.subv_gift_box').forEach(function (box) {
            box.classList.add('active');
          });
        }
        if (onetimeBlock) {
          onetimeBlock.querySelectorAll('.subv_gift_box').forEach(function (box, i) {
            box.classList.toggle('active', i < 3);
          });
        }
        return;
      }

      document.querySelectorAll('.bb_gift_col, .subv_gift_box').forEach(function (el) {
        el.classList.add('active');
      });
    }

    function selectCard(idx) {
      var card = document.querySelector('.sub-option-card[data-card-index="' + idx + '"]');
      if (!card) return;
      if (!card.classList.contains('selected')) {
        /* .sub-option-card is the <label> wrapping the radio — clicking it
          reuses the existing selection logic (radio check + price/badge sync)
          already bound in the sub-block-wrap script. This also runs
          syncGiftCols, which we override right after. */
        card.click();
      }
      forceAllGiftsActive();
    }

    document.addEventListener('change', function (e) {
      if (e.target.name !== 'onetime_subscription') return;
      if (e.target.value === 'onetime') {
        selectCard(1);
      } else if (e.target.value === 'subscription') {
        selectCard(3);
      }
    });

    /* Gifts active from the start too, in case the page loads
      with a bag already selected but gifts weren't all active. */
    forceAllGiftsActive();

    /* Also re-force after any bundle:change (kids qty, flavor switch etc.)
      so gifts never get toggled off on these two pages. */
    document.addEventListener('bundle:change', forceAllGiftsActive);
  }

  /* ═══════════════════════════════════════════════════
     OFFER PAGE
  ═══════════════════════════════════════════════════ */
  function initOfferPage(section) {
    if (section.dataset.subInitialized) return;
    section.dataset.subInitialized = 'true';

    var isVitaminesPage = matchesAnyPath(window.location.pathname, VITAMINES_STYLE_PAGE_PATHS);

    var bundleCols  = section.querySelectorAll('.bb_bundle_col');
    var radioInputs = section.querySelectorAll('input[name="onetime_subscription"]');
    var atcBtn      = section.querySelector('.bb_atc_btn');
    var atcLink     = atcBtn ? atcBtn.querySelector('.bb_atc_btnlink') : null;
    var subPrices   = section.querySelector('.bb_atc_prices_subscribe');
    var otPrices    = section.querySelector('.bb_atc_prices_onetime');
    var announceEl  = section.querySelector('.bb_atc_subscribe');
    var iconsBlock  = section.querySelector('.bb_atc_icons-block');
    var buyOnceBtn      = section.querySelector('.bb_buyonce_btn');
    var buyOnceOrigHref = buyOnceBtn ? buyOnceBtn.getAttribute('href') : null;

    var curIdx = 2;
    var activeCol = section.querySelector('.bb_bundle_col.active');
    if (activeCol && activeCol.dataset.index) curIdx = parseInt(activeCol.dataset.index) || 2;

    var selectedCard = document.querySelector('.sub-option-card.selected');
    if (selectedCard) {
      var selectedIdx = parseInt(selectedCard.getAttribute('data-card-index'));
      if (selectedIdx && IDX_CLASS[selectedIdx]) curIdx = selectedIdx;
    }

    var curMode = 'subscription';
    var checkedRadio = section.querySelector('input[name="onetime_subscription"]:checked');
    if (checkedRadio) curMode = checkedRadio.value;

    function updatePriceSpans(idx) {
      var cls = IDX_CLASS[idx];
      ['subv-header-price_sale','subv-header-price_compare','subv-header-perday','bba_compare_price','bba_sale_price'].forEach(function (name) {
        section.querySelectorAll('.' + name).forEach(function (el) {
          el.style.display = el.classList.contains(cls) ? '' : 'none';
        });
      });
    }

    function updateGiftBoxes(idx) {
      var activeCount = isVitaminesPage
        ? section.querySelectorAll('.subv_gift_box').length
        : idx;
      section.querySelectorAll('.subv_gift_box').forEach(function (box, i) {
        box.classList.toggle('active', i < activeCount);
      });
    }

    function setParam(url, key, val) {
      var re = new RegExp('([?&])' + key + '=[^&]*');
      return re.test(url)
        ? url.replace(re, '$1' + key + '=' + val)
        : url + (url.indexOf('?') !== -1 ? '&' : '?') + key + '=' + val;
    }

    function updateBuyOnceBtn(idx) {
      if (!buyOnceBtn || !buyOnceOrigHref) return;
      var link = /quantity=/.test(buyOnceOrigHref)
        ? buyOnceOrigHref.replace(/quantity=\d+/, 'quantity=' + idx)
        : buyOnceOrigHref + (buyOnceOrigHref.indexOf('?') !== -1 ? '&' : '?') + 'quantity=' + idx;
      link = setParam(link, 'bundle', idx);
      link = setParam(link, 'plan', 'onetime');
      buyOnceBtn.setAttribute('href', link);
      var cls = IDX_CLASS[idx];
      buyOnceBtn.querySelectorAll('.bb_buynow_msg').forEach(function (el) {
        el.style.display = el.classList.contains('bb_flabor_' + cls) ? '' : 'none';
      });
    }

    function updateLink() {
      if (!atcBtn || !atcLink) return;
      var attr = curMode === 'subscription' ? 'subscribe-link' : 'onetime-link';
      var base = atcBtn.getAttribute(attr) || '#';
      var link = /quantity=/.test(base)
        ? base.replace(/quantity=\d+/, 'quantity=' + curIdx)
        : base + (base.indexOf('?') !== -1 ? '&' : '?') + 'quantity=' + curIdx;
      link = setParam(link, 'bundle', curIdx);
      link = setParam(link, 'plan', curMode);
      if (isVitaminesPage) {
        link = setParam(link, 'src', 'vitamines');
        
        var slug = getCurrentVitaminesSlug(window.location.pathname);
        if (slug) link = setParam(link, 'frompage', slug);
        
        var kidsRadio = document.querySelector('.kids_bundle_values input[name="kids_quantity"]:checked');
        link = setParam(link, 'kids', kidsRadio ? (kidsRadio.value || '1') : '1');
      }
      atcLink.setAttribute('href', link);
    }

    function switchIndex(idx) {
      curIdx = idx;
      updatePriceSpans(idx);
      updateSubtitleLabel(section, idx);
      updateGiftBoxes(idx);
      updateBuyOnceBtn(idx);
      updateLink();
    }

    function switchMode(mode) {
      curMode = mode;
      if (subPrices)  subPrices.style.display  = mode === 'subscription' ? '' : 'none';
      if (otPrices)   otPrices.style.display   = mode === 'onetime'      ? '' : 'none';
      if (announceEl) announceEl.style.display  = 'none';
      if (iconsBlock) iconsBlock.style.display  = mode === 'subscription' ? '' : 'none';

      var footerLabel = section.querySelector('.bb_atc_footer-label');
      if (footerLabel) footerLabel.style.display = mode === 'subscription' ? '' : 'none';

      section.querySelectorAll('.subscription_bundle_value').forEach(function (v) {
        v.classList.remove('is-active');
      });
      var target = mode === 'subscription'
        ? section.querySelector('.subscribe__save')
        : section.querySelector('.onetime_purchase');
      if (target) target.classList.add('is-active');

      updateLink();
    }

    bundleCols.forEach(function (col) {
      col.addEventListener('click', function () {
        bundleCols.forEach(function (c) { c.classList.remove('active'); });
        col.classList.add('active');
        switchIndex(parseInt(col.dataset.index));
      });
    });

    document.querySelectorAll('[data-card-index]').forEach(function (card) {
      card.addEventListener('click', function () {
        var idx = parseInt(this.getAttribute('data-card-index'));
        if (!idx || !IDX_CLASS[idx]) return;
        curIdx = idx;
        updatePriceSpans(idx);
        updateSubtitleLabel(section, idx);
        updateGiftBoxes(idx);
        updateLink();
      });
    });

    radioInputs.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) switchMode(radio.value);
      });
    });

    if (isVitaminesPage) {
      document.addEventListener('change', function (e) {
        if (e.target.name !== 'kids_quantity') return;
        updateLink();
      });
    }

    switchIndex(curIdx);
    switchMode(curMode);
  }

  /* ═══════════════════════════════════════════════════
     FLAVOR PAGE (destination — URL params hain)
  ═══════════════════════════════════════════════════ */
  function initDestinationPage() {
    if (document.documentElement.dataset.subDestInitialized) return;
    document.documentElement.dataset.subDestInitialized = 'true';

    var urlParams      = new URLSearchParams(window.location.search);
    var paramBundle    = parseInt(urlParams.get('bundle'));
    var paramPlan      = urlParams.get('plan');
    var isVitaminesDest = urlParams.get('src') === 'vitamines';

    
    if (isVitaminesDest) {
      document.body.classList.add('from-vitamines');

      paramBundle = Math.min(paramBundle || 2, 2);

      /* atc_top_usps hide */
      var atcTopUsps = document.querySelector('.atc_top_usps');
      if (atcTopUsps) atcTopUsps.style.display = 'none';

    
      function activateGiftCols() {
        document.querySelectorAll('.bb_gift_col').forEach(function (col) {
          col.classList.add('active');
          var blankBox = col.querySelector('.bb_gift_blank');
          var giftBox  = col.querySelector('.bb_gift_box');
          if (blankBox) blankBox.style.display = 'none';
          if (giftBox)  giftBox.style.display  = 'flex';
        });
      }
      activateGiftCols();

      var giftObserver = new MutationObserver(function () {
        activateGiftCols();
      });
      giftObserver.observe(document.body, { childList: true, subtree: true });

      var maxFlavors = 2;

      /* Max flavors — capture phase interceptor ONLY */
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-action="add"], [data-action="increase"]');
        if (!btn) return;
        var bundleRoot = btn.closest('[data-bundle-root]');
        if (!bundleRoot) return;
        var total = parseInt(bundleRoot.dataset.totalSelected) || 0;
        if (total >= maxFlavors) {
          e.stopImmediatePropagation();
          e.preventDefault();
        }
      }, true);

      
      document.addEventListener('bundle:change', function (e) {
        if (!e.detail) return;
        var units = e.detail.totalUnits || 0;
        document.querySelectorAll('[data-bundle-root] [data-action="add"], [data-bundle-root] [data-action="increase"]').forEach(function (btn) {
          if (units >= maxFlavors) {
            btn.setAttribute('disabled', 'disabled');
            btn.style.pointerEvents = 'none';
            btn.style.opacity = '0.4';
          } else {
            btn.removeAttribute('disabled');
            btn.style.pointerEvents = '';
            btn.style.opacity = '';
          }
        });
        setTimeout(function () { activateGiftCols(); }, 0);
      });
    }

    if (!paramBundle && !paramPlan) return;

    var subWrapper = document.querySelector('.subscription_bundle_wrapper');
    if (!subWrapper) return;

    var radioInputs = subWrapper.querySelectorAll('input[name="onetime_subscription"]');
    var giftBoxes   = subWrapper.querySelectorAll('.subv_gift_box');
    var _syncInProgress = false;

    var pricingTiers = null;
    var priceActvCls = IDX_CLASS[paramBundle] || 'two';
    var subSection   = subWrapper.querySelector('.subscribe__save');
    var otSection    = subWrapper.querySelector('.onetime_purchase');
    var pricingEl    = document.querySelector('[data-sub-bundle-pricing]');
    if (pricingEl) {
      try { pricingTiers = JSON.parse(pricingEl.textContent); } catch(e) {}
    }

    function updateSubBundlePricing(units) {
      if (!pricingTiers || !pricingTiers.length) return;
      var qty  = (units > 0) ? units : paramBundle;
      var tier = null;
      for (var t = 0; t < pricingTiers.length; t++) {
        if (parseInt(pricingTiers[t].qty) === qty) { tier = pricingTiers[t]; break; }
      }
      if (!tier) return;
      if (subSection) {
        var sp = subSection.querySelector('.subv-header-price_sale.'    + priceActvCls);
        var sc = subSection.querySelector('.subv-header-price_compare.' + priceActvCls);
        var sd = subSection.querySelector('.subv-header-perday.'        + priceActvCls);
        if (sp && tier.sub_price)   sp.textContent = tier.sub_price;
        if (sc && tier.sub_compare) sc.textContent = tier.sub_compare;
        if (sd && tier.sub_cup)     sd.textContent = tier.sub_cup;
      }
      if (otSection) {
        var op = otSection.querySelector('.subv-header-price_sale.'    + priceActvCls);
        var oc = otSection.querySelector('.subv-header-price_compare.' + priceActvCls);
        var od = otSection.querySelector('.subv-header-perday.'        + priceActvCls);
        if (op && tier.onetime_price)   op.textContent = tier.onetime_price;
        if (oc && tier.onetime_compare) oc.textContent = tier.onetime_compare;
        if (od && tier.onetime_cup)     od.textContent = tier.onetime_cup;
      }
    }

    if (pricingTiers) updateSubBundlePricing(paramBundle);

    function reapplyButtonMessages(qty, defaultqty) {
      if (typeof jQuery === 'undefined') return;
      var $orig = jQuery('.custom-bundle-atc-original');
      if (!$orig.length) return;
      $orig.find('.custom-bundle-atc-message').hide();
      if (defaultqty <= 2) {
        if (qty <= 1 && defaultqty <= 1) {
          if (qty == 0) { $orig.find('.cunstom-bundle-atc-two-step').css('display', 'flex'); }
          else { $orig.find('.custom-bundle-atc-label').css('display', 'flex'); }
        } else if (qty == 0 && defaultqty <= 2) {
          $orig.find('.cunstom-bundle-atc-three-step').css('display', 'flex');
        } else if (defaultqty > qty) {
          $orig.find('.cunstom-bundle-atc-two-step').css('display', 'flex');
        } else {
          $orig.find('.custom-bundle-atc-label').css('display', 'flex');
        }
      } else if (qty == 0 && defaultqty <= 3) {
        $orig.find('.custom-bundle-atc-prompt').css('display', 'flex');
      } else if (qty == 2) {
        $orig.find('.cunstom-bundle-atc-two-step').css('display', 'flex');
      } else if (qty == 1) {
        $orig.find('.cunstom-bundle-atc-three-step').css('display', 'flex');
      } else {
        $orig.find('.custom-bundle-atc-label').css('display', 'flex');
      }
      var $btn = $orig.find('[data-bundle-atc-button]');
      var isReady = $orig.find('.custom-bundle-atc-label').is(':visible');
      if (!isReady) {
        $btn.attr('disabled', 'disabled').attr('aria-disabled', 'true').addClass('is-empty');
        $orig.find('[data-price-pill]').hide();
      } else {
        $btn.removeAttr('disabled').attr('aria-disabled', 'false').removeClass('is-empty');
      }
    }

    function syncSubscriptionOptions(mode) {
      if (_syncInProgress) return;
      var optionsEl = document.querySelector('.subscription-options');
      if (!optionsEl) return;
      var currentCard = optionsEl.querySelector('[data-option][aria-checked="true"]');
      var currentMode = currentCard ? currentCard.getAttribute('data-option') : null;
      if (currentMode === mode) return;
      _syncInProgress = true;
      var $atcOriginal = typeof jQuery !== 'undefined' ? jQuery('.custom-bundle-atc-original') : null;
      if ($atcOriginal) $atcOriginal.css('visibility', 'hidden');
      document.dispatchEvent(new CustomEvent('bundle:purchaseTypeChange', {
        detail: { purchaseType: mode }
      }));
      setTimeout(function () {
        _syncInProgress = false;
        var stateEl = document.querySelector('[data-state-json]');
        var totalUnits = 0;
        try {
          if (stateEl && stateEl.textContent.trim()) {
            totalUnits = JSON.parse(stateEl.textContent).total_units || 0;
          }
        } catch(e) {}
        reapplyButtonMessages(totalUnits, paramBundle);
        if ($atcOriginal) $atcOriginal.css('visibility', '');
      }, 50);
    }

    if (paramBundle && IDX_CLASS[paramBundle]) {
      var cls = IDX_CLASS[paramBundle];
      ['subv-header-price_sale', 'subv-header-price_compare', 'subv-header-perday'].forEach(function (name) {
        subWrapper.querySelectorAll('.' + name).forEach(function (el) {
          el.style.display = el.classList.contains(cls) ? '' : 'none';
        });
      });
      updateSubtitleLabel(subWrapper, paramBundle);
    }

    if (paramPlan === 'subscription' || paramPlan === 'onetime') {
      radioInputs.forEach(function (r) { r.checked = r.value === paramPlan; });
      var subVal = subWrapper.querySelector('.subscribe__save');
      var otVal  = subWrapper.querySelector('.onetime_purchase');
      if (subVal) subVal.classList.toggle('is-active', paramPlan === 'subscription');
      if (otVal)  otVal.classList.toggle('is-active', paramPlan === 'onetime');
      var topUsps = document.querySelector('.atc_top_usps');
      if (topUsps && !isVitaminesDest) topUsps.style.display = paramPlan === 'subscription' ? 'flex' : 'none';
      var guaranteeBlockInit = document.querySelector('.cpblock--guarantee_block');
      if (guaranteeBlockInit) guaranteeBlockInit.style.display = paramPlan === 'onetime' ? 'none' : '';
      setTimeout(function () { syncSubscriptionOptions(paramPlan); }, 150);
    }

    var minGifts = paramBundle || 0;

    if (isVitaminesDest) {
      minGifts = giftBoxes.length;
      giftBoxes.forEach(function (box) { box.classList.add('active'); });
    } else {
      giftBoxes.forEach(function (box, i) {
        box.classList.toggle('active', i < minGifts);
      });
    }

    document.addEventListener('bundle:change', function (e) {
      if (!e.detail) return;
      var units = e.detail.totalUnits || 0;
      if (giftBoxes.length > 0) {
        var show = isVitaminesDest ? giftBoxes.length : Math.max(minGifts, units);
        giftBoxes.forEach(function (box, i) {
          box.classList.toggle('active', i < show);
        });
      }
      updateSubBundlePricing(units);
    });

    document.addEventListener('change', function (e) {
      if (e.target.name !== 'onetime_subscription') return;
      if (!e.target.closest('.subscription_bundle_wrapper')) return;
      var wrapper = e.target.closest('.subscription_bundle_wrapper');
      var mode    = e.target.value;
      var subVal  = wrapper.querySelector('.subscribe__save');
      var otVal   = wrapper.querySelector('.onetime_purchase');
      if (subVal) subVal.classList.toggle('is-active', mode === 'subscription');
      if (otVal)  otVal.classList.toggle('is-active', mode === 'onetime');
      if (!isVitaminesDest) {
        var topUsps2 = document.querySelector('.atc_top_usps');
        if (topUsps2) topUsps2.style.display = mode === 'subscription' ? 'flex' : 'none';
      }
      var guaranteeBlock = document.querySelector('.cpblock--guarantee_block');
      if (guaranteeBlock) guaranteeBlock.style.display = mode === 'onetime' ? 'none' : '';
      syncSubscriptionOptions(mode);
      var footerLabel = document.querySelector('.bb_atc_footer-label');
      if (footerLabel) footerLabel.style.display = mode === 'subscription' ? '' : 'none';
    });
  }

  /* ═══════════════════════════════════════════════════
     BONJOUR PAGE
  ═══════════════════════════════════════════════════ */
  function initBonjourPage() {
    if (document.documentElement.dataset.subBonjourInitialized) return;
    document.documentElement.dataset.subBonjourInitialized = 'true';

    var subWrapper = document.querySelector('.subscription_bundle_wrapper');
    if (!subWrapper) return;

    var giftBoxes  = subWrapper.querySelectorAll('.subv_gift_box');
    var subSection = subWrapper.querySelector('.subscribe__save');
    var otSection  = subWrapper.querySelector('.onetime_purchase');
    var pricingEl  = document.querySelector('[data-sub-bundle-pricing]');
    var pricingTiers = null;
    var _syncInProgress = false;

    if (pricingEl) {
      try { pricingTiers = JSON.parse(pricingEl.textContent); } catch(e) {}
    }

    giftBoxes.forEach(function (box) { box.classList.remove('active'); });

    function getTier(units) {
      if (!pricingTiers || !pricingTiers.length) return null;
      for (var t = 0; t < pricingTiers.length; t++) {
        if (parseInt(pricingTiers[t].qty) === units) return pricingTiers[t];
      }
      return pricingTiers[pricingTiers.length - 1];
    }

    function updatePriceSpanVisibility(units) {
      var cls = IDX_CLASS[Math.min(units, 3)] || 'three';
      ['subv-header-price_sale', 'subv-header-price_compare', 'subv-header-perday'].forEach(function (name) {
        subWrapper.querySelectorAll('.' + name).forEach(function (el) {
          el.style.display = el.classList.contains(cls) ? '' : 'none';
        });
      });
      updateSubtitleLabel(subWrapper, Math.min(units, 3));
    }

    function updatePriceContent(units) {
      var tier = getTier(units);
      if (!tier) return;
      var cls = IDX_CLASS[Math.min(units, 3)] || 'three';
      if (subSection) {
        var sp = subSection.querySelector('.subv-header-price_sale.'    + cls);
        var sc = subSection.querySelector('.subv-header-price_compare.' + cls);
        var sd = subSection.querySelector('.subv-header-perday.'        + cls);
        if (sp && tier.sub_price)   sp.textContent = tier.sub_price;
        if (sc && tier.sub_compare) sc.textContent = tier.sub_compare;
        if (sd && tier.sub_cup)     sd.textContent = tier.sub_cup;
      }
      if (otSection) {
        var op = otSection.querySelector('.subv-header-price_sale.'    + cls);
        var oc = otSection.querySelector('.subv-header-price_compare.' + cls);
        var od = otSection.querySelector('.subv-header-perday.'        + cls);
        if (op && tier.onetime_price)   op.textContent = tier.onetime_price;
        if (oc && tier.onetime_compare) oc.textContent = tier.onetime_compare;
        if (od && tier.onetime_cup)     od.textContent = tier.onetime_cup;
      }
    }

    updatePriceSpanVisibility(1);
    updatePriceContent(1);

    function syncSubscriptionOptions(mode) {
      if (_syncInProgress) return;
      var optionsEl = document.querySelector('.subscription-options');
      if (!optionsEl) return;
      var currentCard = optionsEl.querySelector('[data-option][aria-checked="true"]');
      var currentMode = currentCard ? currentCard.getAttribute('data-option') : null;
      if (currentMode === mode) return;
      _syncInProgress = true;
      document.dispatchEvent(new CustomEvent('bundle:purchaseTypeChange', {
        detail: { purchaseType: mode }
      }));
      setTimeout(function () { _syncInProgress = false; }, 300);
    }

    document.addEventListener('bundle:change', function (e) {
      if (!e.detail) return;
      var units = e.detail.totalUnits || 0;
      giftBoxes.forEach(function (box, i) {
        box.classList.toggle('active', i < units);
      });
      if (units > 0) {
        updatePriceSpanVisibility(units);
        updatePriceContent(units);
      }
    });

    var checkedRadio = subWrapper.querySelector('input[name="onetime_subscription"]:checked');
    if (checkedRadio) {
      var initMode = checkedRadio.value;
      if (subSection) subSection.classList.toggle('is-active', initMode === 'subscription');
      if (otSection)  otSection.classList.toggle('is-active', initMode === 'onetime');
      var footerLabelInit = subWrapper.querySelector('.bb_atc_footer-label') || document.querySelector('.bb_atc_footer-label');
      if (footerLabelInit) footerLabelInit.style.display = initMode === 'subscription' ? '' : 'none';
    }

    document.addEventListener('change', function (e) {
      if (e.target.name !== 'onetime_subscription') return;
      if (!e.target.closest('.subscription_bundle_wrapper')) return;
      var mode = e.target.value;
      if (subSection) subSection.classList.toggle('is-active', mode === 'subscription');
      if (otSection)  otSection.classList.toggle('is-active', mode === 'onetime');
      syncSubscriptionOptions(mode);
      var footerLabel = document.querySelector('.bb_atc_footer-label');
      if (footerLabel) footerLabel.style.display = mode === 'subscription' ? '' : 'none';
    });
  }

  /* ═══════════════════════════════════════════════════
     FIRST-ORDER PAGE
  ═══════════════════════════════════════════════════ */
  function initFirstOrderPage() {
    if (document.documentElement.dataset.subFirstOrderInitialized) return;
    document.documentElement.dataset.subFirstOrderInitialized = 'true';

    var bundleCols      = document.querySelectorAll('.bb_bundle_col');
    var buyOnceBtn      = document.querySelector('.bb_buyonce_btn');
    var buyOnceOrigHref = buyOnceBtn ? buyOnceBtn.getAttribute('href') : null;

    var curIdx    = 2;
    var activeCol = document.querySelector('.bb_bundle_col.active');
    if (activeCol && activeCol.dataset.index) curIdx = parseInt(activeCol.dataset.index) || 2;

    function setParam(url, key, val) {
      var re = new RegExp('([?&])' + key + '=[^&]*');
      return re.test(url)
        ? url.replace(re, '$1' + key + '=' + val)
        : url + (url.indexOf('?') !== -1 ? '&' : '?') + key + '=' + val;
    }

    function updateBuyOnceBtn(idx) {
      if (!buyOnceBtn || !buyOnceOrigHref) return;
      var link = /quantity=/.test(buyOnceOrigHref)
        ? buyOnceOrigHref.replace(/quantity=\d+/, 'quantity=' + idx)
        : buyOnceOrigHref + (buyOnceOrigHref.indexOf('?') !== -1 ? '&' : '?') + 'quantity=' + idx;
      link = setParam(link, 'bundle', idx);
      link = setParam(link, 'plan', 'onetime');
      buyOnceBtn.setAttribute('href', link);
      var cls = IDX_CLASS[idx];
      buyOnceBtn.querySelectorAll('.bb_buynow_msg').forEach(function (el) {
        el.style.display = el.classList.contains('bb_flabor_' + cls) ? '' : 'none';
      });
    }

    bundleCols.forEach(function (col) {
      col.addEventListener('click', function () {
        bundleCols.forEach(function (c) { c.classList.remove('active'); });
        col.classList.add('active');
        curIdx = parseInt(col.dataset.index) || curIdx;
        updateBuyOnceBtn(curIdx);
      });
    });

    updateBuyOnceBtn(curIdx);
  }

    /* ═══════════════════════════════════════════════════
     ENFANT FIRST-ORDER PAGE (+ night-first-order-pdp)
  ═══════════════════════════════════════════════════ */
  function initEnfantFirstOrderPage() {
    if (document.documentElement.dataset.subEnfantFirstOrderInitialized) return;
    document.documentElement.dataset.subEnfantFirstOrderInitialized = 'true';

    var subWrapper = document.querySelector('.subscription_bundle_wrapper');
    if (!subWrapper) return;

    /* enfant-first-order-90-day needs a different gift-box split:
       subscribe block = ALL gifts active, onetime block = only first
       3 gifts active. Every other enfant-first-order page keeps the
       original behavior (all gifts in the whole wrapper active). */
    var isNewSub = window.location.pathname.indexOf('/pages/enfant-first-order-90-day') !== -1;

    var giftBoxes = subWrapper.querySelectorAll('.subv_gift_box');

    function activateAllGifts() {
      if (isNewSub) {
        var subscribeBlock = subWrapper.querySelector('.subscribe__save');
        var onetimeBlock   = subWrapper.querySelector('.onetime_purchase');
        if (subscribeBlock) {
          subscribeBlock.querySelectorAll('.subv_gift_box').forEach(function (box) {
            box.classList.add('active');
          });
        }
        if (onetimeBlock) {
          onetimeBlock.querySelectorAll('.subv_gift_box').forEach(function (box, i) {
            box.classList.toggle('active', i < 3);
          });
        }
      } else {
        giftBoxes.forEach(function (box) { box.classList.add('active'); });
      }
    }

    activateAllGifts();

    document.addEventListener('bundle:change', function () {
      activateAllGifts();
    });

    var footerLabel = document.querySelector('.bb_atc_footer-label');

    function updateFooterLabel(mode) {
      if (footerLabel) footerLabel.style.display = mode === 'onetime' ? 'none' : '';
    }

    var checkedRadio = document.querySelector('input[name="onetime_subscription"]:checked');
    if (checkedRadio) updateFooterLabel(checkedRadio.value);

    document.addEventListener('change', function (e) {
      if (e.target.name !== 'onetime_subscription') return;
      updateFooterLabel(e.target.value);
    });

    /* Buy-once link (only when block uses the <a> version via enable_link) */
    var buyOnceLink     = document.querySelector('a.bb_buyonce_btn');
    var buyOnceLinkHref = buyOnceLink ? buyOnceLink.getAttribute('href') : null;

    function setParam(url, key, val) {
      var re = new RegExp('([?&])' + key + '=[^&]*');
      return re.test(url)
        ? url.replace(re, '$1' + key + '=' + val)
        : url + (url.indexOf('?') !== -1 ? '&' : '?') + key + '=' + val;
    }

    function updateBuyOnceLink(idx) {
      if (!buyOnceLink || !buyOnceLinkHref || !IDX_CLASS[idx]) return;
      var link = /quantity=/.test(buyOnceLinkHref)
        ? buyOnceLinkHref.replace(/quantity=\d+/, 'quantity=' + idx)
        : buyOnceLinkHref + (buyOnceLinkHref.indexOf('?') !== -1 ? '&' : '?') + 'quantity=' + idx;
      link = setParam(link, 'bundle', idx);
      link = setParam(link, 'plan', 'onetime');
      buyOnceLink.setAttribute('href', link);
      var cls = IDX_CLASS[idx];
      buyOnceLink.querySelectorAll('.bb_buynow_msg').forEach(function (el) {
        el.style.display = el.classList.contains('bb_flabor_' + cls) ? '' : 'none';
      });
    }

    if (buyOnceLink && buyOnceLinkHref) {
      var initIdx = 2;
      var selectedCard = document.querySelector('.sub-option-card.selected[data-card-index]');
      if (selectedCard) {
        var selIdx = parseInt(selectedCard.getAttribute('data-card-index'));
        if (IDX_CLASS[selIdx]) initIdx = selIdx;
      }
      updateBuyOnceLink(initIdx);

      document.addEventListener('click', function (e) {
        var card = e.target.closest('.sub-option-card[data-card-index]');
        if (!card) return;
        updateBuyOnceLink(parseInt(card.getAttribute('data-card-index')));
      });
    }

    /* enfant-first-order-90-day ONLY: subscribe block me sale + compare
       price hamesha "three" wali dikhani hai, chahe koi bhi bag select ho.
       Sirf .subscribe__save block ke andar scoped — onetime block touch
       nahi hota. Kisi aur enfant-first-order page pe ye nahi chalega. */
    if (isNewSub) {
      var subscribeBlockPrice = subWrapper.querySelector('.subscribe__save');
      if (subscribeBlockPrice) {
        (function () {
          function forceThreePrice() {
            subscribeBlockPrice.querySelectorAll('.subv-header-price_sale, .subv-header-price_compare').forEach(function (el) {
              el.style.display = el.classList.contains('three') ? '' : 'none';
            });
          }
          forceThreePrice();
          document.addEventListener('bundle:change', forceThreePrice);
        })();
      }
    }
  }

  /* ═══════════════════════════════════════════════════
     ROUTER
  ═══════════════════════════════════════════════════ */
  function init() {
    initBagModeSync();

    var routerParams = new URLSearchParams(window.location.search);
    if (routerParams.get('src') === 'vitamines') {
      document.body.classList.add('from-vitamines');

      var frompageParam = routerParams.get('frompage');
      if (frompageParam && VITAMINES_STYLE_PAGE_SLUGS.indexOf(frompageParam) !== -1) {
        document.body.classList.add('from-' + frompageParam);
      }
    }

    var isEnfantFirstOrder = matchesAnyPath(window.location.pathname, ENFANT_FIRST_ORDER_PATHS);

    if (isEnfantFirstOrder) {
      initEnfantFirstOrderPage();
      return;
    }

    var bundleSection  = document.querySelector('.bundle_builder_section');
    var isFirstOrder   = window.location.pathname.indexOf('/pages/first-order') !== -1;
    var urlParams      = new URLSearchParams(window.location.search);
    var paramBundle    = parseInt(urlParams.get('bundle'));
    var paramPlan      = urlParams.get('plan');
    var isVitaminesSrc = urlParams.get('src') === 'vitamines';

    if (bundleSection) {
      if (document.querySelector('input[name="onetime_subscription"]')) {
        initOfferPage(bundleSection);
      }
    } else if (isFirstOrder) {
      initFirstOrderPage();
    } else if (paramBundle || paramPlan) {
      if (isVitaminesSrc || document.querySelector('input[name="onetime_subscription"]')) {
        initDestinationPage();
      }
    } else {
      if (document.querySelector('input[name="onetime_subscription"]')) {
        initBonjourPage();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pagehide', function () {
    var bundleSection = document.querySelector('.bundle_builder_section');
    if (!bundleSection) return;
    document.querySelectorAll('input[name="onetime_subscription"]').forEach(function (r) {
      r.checked = r.value === 'subscription';
    });
    delete bundleSection.dataset.subInitialized;
  });

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var bundleSection = document.querySelector('.bundle_builder_section');
    if (!bundleSection) return;
    delete bundleSection.dataset.subInitialized;
    init();
  });

  document.addEventListener('shopify:section:load', function () {
    var bundleSection = document.querySelector('.bundle_builder_section');
    if (bundleSection) {
      delete bundleSection.dataset.subInitialized;
    } else {
      delete document.documentElement.dataset.subDestInitialized;
      delete document.documentElement.dataset.subBonjourInitialized;
      delete document.documentElement.dataset.subFirstOrderInitialized;
      delete document.documentElement.dataset.subEnfantFirstOrderInitialized;
    }
    init();
  });

})();